// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"29d7dcdf","504":"29d7dcdf","527":"29d7dcdf","580":"29d7dcdf","596":"29d7dcdf","598":"29d7dcdf","719":"29d7dcdf","749":"29d7dcdf","979":"38c69e57"}[chunkId] + ".chunk.css";
};